import { render } from "./member_choose.vue?vue&type=template&id=497f56c1&scoped=true"
import script from "./member_choose.vue?vue&type=script&lang=js"
export * from "./member_choose.vue?vue&type=script&lang=js"

import "./member_choose.vue?vue&type=style&index=0&id=497f56c1&scoped=true&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-497f56c1"]])

export default __exports__